import { useCallback } from 'react';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { NotificationDispatch } from '@tryhackme/thm-ui-components';
import { StandardActionModal } from 'src/common/components/standard-action-modal';
import { StyledModalIcon } from 'src/common/components/standard-action-modal/standard-action-modal.styles';
import { useResetUserProgressMutation } from 'src/features/room/room.slice';
import { OptionsModalProps } from 'src/features/room/room.types';
import { setIsRoomComplete } from 'src/app/reducers/room/room.reducer';
import { useAppDispatch } from 'src/app/hooks';
const dispatchNotification = () => NotificationDispatch('success', 'Done! Room progress has been reset');
const iconComponent = <StyledModalIcon icon={faCircleExclamation} data-icon="error" />;
export const ResetProgressModal = ({
  open,
  onOpenChange,
  roomCode,
  setRoomProgress,
  resetToFirstTask
}: OptionsModalProps & {
  setRoomProgress: React.Dispatch<React.SetStateAction<number>>;
  resetToFirstTask?: VoidFunction;
}) => {
  const dispatch = useAppDispatch();
  const [resetUserProgressTrigger, {
    isLoading
  }] = useResetUserProgressMutation({
    fixedCacheKey: 'shared-reset-progress'
  });
  const handleModalAction = useCallback(async () => {
    try {
      if (resetToFirstTask) {
        resetToFirstTask();
      }
      const result = await resetUserProgressTrigger({
        roomCode
      }).unwrap();
      const resetUserProgress = result.status === 'success';
      if (resetUserProgress) {
        setRoomProgress(0);
        dispatchNotification();
        dispatch(setIsRoomComplete(false));
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, [dispatch, resetToFirstTask, resetUserProgressTrigger, roomCode, setRoomProgress]);
  return <StandardActionModal modalTitleText="Reset Your Progress" modalBodyText="You will keep your points but all your answers in this room will be erased." actionButtonTitle="Yes, Reset my Progress" dismissButtonTitle="Cancel" handleModalAction={handleModalAction} showIcon iconComponent={iconComponent} open={open} onOpenChange={onOpenChange} actionLoading={isLoading} data-sentry-element="StandardActionModal" data-sentry-component="ResetProgressModal" data-sentry-source-file="reset-progress-modal.tsx" />;
};